import React, { Component } from 'react';
import Pagination from 'react-js-pagination';

export default class Paginator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      meta_data: props.data,
    };
    this.handlePageChange = this.handlePageChange.bind(this);
    this.renderShowRecords = this.renderShowRecords.bind(this);
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.data && nextProps.data !== this.props.data) {
      this.setState({ meta_data: nextProps.data });
    }
  }

  handlePageChange(pageNumber) {
    if (this.state.meta_data['current-page'] !== pageNumber) {
      this.props.handlePageChange(pageNumber);
    }
  }

  renderShowRecords() {
    if (this.state.meta_data['total-records'] > this.state.meta_data['page-size']) {

      let pageNumber = parseInt(this.state.meta_data['current-page'], 10);
      let pageSize = parseInt(this.state.meta_data['page-size'], 10);
      let totalRecord = parseInt(this.state.meta_data['total-records'], 10);
      let nextPage = (pageNumber - 1) * pageSize + pageSize;

      let showFrom = parseInt((pageNumber - 1) * pageSize, 10) + 1;
      let showTo = nextPage > totalRecord ? totalRecord : nextPage;;

      return (
        <div className="pagesize">
          Showing {showFrom} to {showTo} of {totalRecord} entries.
        </div>
      );
    }
  }

  render() {
    return (
      this.state.meta_data ?
        <div className="DivPager">
          <Pagination
            activePage={this.state.meta_data['current-page']}
            itemsCountPerPage={this.state.meta_data['page-size']}
            totalItemsCount={this.state.meta_data['total-records']}
            pageRangeDisplayed={5}
            onChange={this.handlePageChange}
            prevPageText="Prev"
            nextPageText="Next"
            hideDisabled={true}
          />
          {this.renderShowRecords()}
        </div>
        :
        <div></div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pagination.js